import * as React from "react";
import { Badge as MantineBadge } from "@mantine/core";
import styled, { css } from "styled-components";
const mapStyle = (style) => style === "default" ? "gray" : style;
const StyledBadge = styled(MantineBadge)(
  ({ theme, color }) => css`
    text-transform: none;
    background: ${theme.colors.button[color].background};
    color: ${theme.colors.button[color].color};

    .mantine-Badge-label {
      font-size: ${theme.fonts.size.small};
    }
  `
);
const Badge = ({
  bsStyle = "default",
  className = void 0,
  children = void 0,
  "data-testid": dataTestid,
  onClick = void 0,
  title = void 0
}, ref) => {
  const color = mapStyle(bsStyle);
  return /* @__PURE__ */ React.createElement(
    StyledBadge,
    {
      color,
      className,
      title,
      "data-testid": dataTestid,
      ref,
      variant: "filled",
      onClick
    },
    children
  );
};
export default React.forwardRef(Badge);
